const prepareDataForSelect = (data, key = 'id', label = 'name') => {
  if (!data || !Array.isArray(data)) return [];
  const isLabelFunc = typeof label === 'function';
  return data.map(element => ({ ...element, key: element[key], label: isLabelFunc ? label(element) : element[label] }));
};

export default prepareDataForSelect;
